<template>
  <component :is="activeComponent" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/views/Dashboard.vue";
import Welcome from "@/views/Welcome.vue";

export default {
  name: "Home",
  metaInfo: {
    title: "Home",
  },
  data() {
    return {};
  },
  computed: {
    userProfile() {
      return this.$store.state.userProfile;
    },
    activeComponent() {
      return this.userProfile ? Dashboard : Welcome;
    },
  },
};
</script>
